{
    "Accessibility menu": "Meniu Accesibilitate",
    "Close": "Închide",
    "Content adjustments": "Ajustări Conținut",
    "Navigation adjustments": "Ajustări Navigare",
    "Text Align": "Text Align",
    "Align Left": "Aliniere la Stânga",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Ajustează Dimensiunea Fontului",
    "Highlight Title": "Evidențiază Titlul",
    "Highlight Links": "Evidențiază Link-urile",
    "Readable Font": "Font Lizibil",
    "Colour adjustments": "Ajustări Culoare",
    "Dark Contrast": "Contrast Întunecat",
    "Light Contrast": "Contrast Deschis",
    "High Contrast": "Contrast Ridicat",
    "High Saturation": "Saturație Ridicată",
    "Low Saturation": "Saturație Scăzută",
    "Monochrome": "Monocrom",
    "Tools": "Instrumente",
    "Reading Guide": "Ghid de Citire",
    "Big Cursor": "Cursor Mare",
    "Increase Font Size": "Mărește Dimensiunea Fontului",
    "Decrease Font Size": "Micșorează Dimensiunea Fontului",
    "Letter Spacing": "Spațiere Litere",
    "Line Height": "Înălțime Linie",
    "Font Weight": "Grosime Font",
    "Dyslexia Font": "Font pentru Dislexie",
    "Language": "Limbă",
    "Accessibility widget": "Deschide Meniul de Accesibilitate",
    "Accessibility Profiles": "Profiluri de Accesibilitate",
    "Cognitive Disability": "Dizabilitate Cognitivă",
    "Seizure Safe": "Sigur pentru Epilepsie",
    "Accessibility statement": "Declarație de Accesibilitate",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Oprește Animațiile",
    "Animation paused": "Animație întreruptă",
    "Reset all settings": "Resetează setările",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
